import {
  FaMedium,
  FaBlog,
  FaGithub,
  FaLinkedin,
  FaEnvelope,
} from "react-icons/fa";

export const links = [
  {
    index: 0,
    title: "Find me on LinkedIn",
    href: "https://www.linkedin.com/in/yingchi-liao/",
    icon: <FaLinkedin />,
  },
  {
    index: 1,
    title: "Find me on Github",
    href: "https://github.com/inchliao/",
    icon: <FaGithub />,
  },
  {
    index: 2,
    title: "Contact me via email",
    href: "mailto:yingchi.liao@outlook.com",
    icon: <FaEnvelope />,
  },
];
